/* tslint:disable */
/* eslint-disable */
/**
 * API SPECS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AppleId
 */
export interface AppleId {
    /**
     * 
     * @type {string}
     * @memberof AppleId
     */
    appleId?: string;
}

/**
 * Check if a given object implements the AppleId interface.
 */
export function instanceOfAppleId(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AppleIdFromJSON(json: any): AppleId {
    return AppleIdFromJSONTyped(json, false);
}

export function AppleIdFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppleId {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'appleId': !exists(json, 'appleId') ? undefined : json['appleId'],
    };
}

export function AppleIdToJSON(value?: AppleId | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'appleId': value.appleId,
    };
}

